import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Header from "../components/Login_Header";
import { ApiError } from "../lib/api";
import {
  deleteAccount,
  getDeleteReasons,
  getProfile,
} from "../lib/profile-api";
import "./DeleteAccount.css";
// import Login_Header from "../components/Login_Header";

export default function DeleteAccount() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [reasons, setReasons] = useState([]);
  const [selectedReasonId, setSelectedReasonId] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const [profileData, reasonsData] = await Promise.all([
          getProfile(),
          getDeleteReasons(),
        ]);
        setProfile(profileData);
        setReasons(reasonsData);
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) {
          navigate("/", { replace: true });
          return;
        }
        setError(
          err instanceof ApiError
            ? err.message
            : "Failed to load your account details.",
        );
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [navigate]);

  async function handleDelete() {
    if (!selectedReasonId) {
      setError("Please select a reason.");
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      await deleteAccount(selectedReasonId, feedback.trim());
      navigate("/account-deleted", { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : "Something went wrong. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) {
    return (
      <div className="page">
        {/* <Login_Header /> */}
        <main className="delete-account">
          <p>Loading…</p>
        </main>
      </div>
    );
  }

  const displayName =
    profile?.displayName || profile?.user?.username || "Your Account";
  const handle = profile?.handle || profile?.user?.username;
  const selectedReason = reasons.find((r) => r.id === selectedReasonId);
  const isOthersSelected =
    selectedReason?.reason_text.trim().toLowerCase() === "others";

  return (
    <div className="page">
      {/* <Login_Header /> */}
      <main className="delete-account">
        <div className="delete-account__user">
          {profile?.avatarURL ? (
            <img
              className="delete-account__avatar"
              src={profile.avatarURL}
              alt=""
            />
          ) : (
            <div
              className="delete-account__avatar delete-account__avatar--placeholder"
              aria-hidden="true"
            >
              {displayName.charAt(0).toUpperCase()}
            </div>
          )}
          <div>
            <p className="delete-account__name">{displayName}</p>
            {handle && <p className="delete-account__handle">@{handle}</p>}
          </div>
        </div>

        <p className="delete-account__notice">
          Your account will be deactivated immediately and scheduled for
          permanent deletion after 90 days. If you log in during this period,
          your account will be restored automatically.
        </p>

        <h2 className="delete-account__heading">
          Give us your valuable feedback
        </h2>
        <p className="delete-account__subheading">
          Your feedback help us to improve. What can we do to keep you as part
          of our community?
        </p>

        <div
          className="delete-account__reasons"
          role="radiogroup"
          aria-label="Reason for deleting"
        >
          {reasons.map((reason) => (
            <label
              key={reason.id}
              className={`reason ${selectedReasonId === reason.id ? "reason--selected" : ""}`}
            >
              <input
                type="radio"
                name="reason"
                checked={selectedReasonId === reason.id}
                onChange={() => setSelectedReasonId(reason.id)}
              />
              {reason.reason_text}
            </label>
          ))}
        </div>

        {isOthersSelected && (
          <div className="delete-account__feedback">
            <textarea
              maxLength={100}
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Tell us more…"
            />
            <p className="delete-account__count">
              {feedback.length}/100 characters
            </p>
          </div>
        )}

        {error && <p className="delete-account__error">{error}</p>}

        <button
          className="delete-account__submit"
          onClick={handleDelete}
          disabled={submitting}
        >
          {submitting ? "Deleting…" : "Delete"}
        </button>
      </main>
    </div>
  );
}
